import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LogService } from '../services/log.service';
import { OnboardingStateService } from '../services/onboarding-state.service';
import { MerchantTypeService } from '../services/merchant-type.service';

export const onboardingGuard: CanActivateFn = (): boolean => {
  const authService = inject(AuthService);
  const onboardingState = inject(OnboardingStateService);
  const merchantTypeService = inject(MerchantTypeService);
  const router = inject(Router);

  const log = inject(LogService);

  const user = authService.getCurrentUser();
  log.debug('OnboardingGuard check', {
    hasUser: !!user,
    onboardingCompleted: user?.onboardingCompleted,
  });

  if (!user) {
    router.navigate(['/login']);
    return false;
  }

  // ✅ Onboarding terminé côté backend
  if (user.onboardingCompleted) {
    log.debug('OnboardingGuard - access granted');
    return true;
  }

  log.debug('OnboardingGuard - onboarding incomplete, redirecting');

  // 🔄 1️⃣ Priorité à l'état local (refresh-safe)
  const state = onboardingState.getState();
  const merchantType = onboardingState.getMerchantType();

  if (state?.currentStep && merchantType) {
    const route = merchantTypeService.getNextStepRoute(
      state.currentStep - 1,
      merchantType,
    );
    log.debug('OnboardingGuard redirect', { route });
    router.navigateByUrl(route);
    return false;
  }

  // 🌐 2️⃣ Fallback backend (ancien comportement)
  const backendStep = user.onboardingStep ?? 0;
  log.debug('OnboardingGuard fallback redirect', { step: backendStep + 1 });
  router.navigate([`/onboarding/step/${backendStep + 1}`]);
  return false;
};
